/* Body Collective product options (replaces the APO Product Options app).
   The theme's product forms skip the browser's own "required" check, and the sticky add to cart bar is a
   separate form that would drop the choices. This makes required dropdowns truly required and carries the
   choices into whichever form the customer submits. */
(() => {
  if (window.__bcOptionsReady) return;
  window.__bcOptionsReady = true;

  const fields = () => [...document.querySelectorAll('.bc-option select[data-bc-required], .bc-option input[required], .bc-option textarea[required]')];
  const errorOf = (field) => field.closest('.bc-option') && field.closest('.bc-option').querySelector('.bc-option__error');

  const mark = (field, bad) => {
    const wrap = field.closest('.bc-option');
    if (!wrap) return;
    wrap.classList.toggle('bc-option--error', bad);
    field.setAttribute('aria-invalid', bad ? 'true' : 'false');
    const err = errorOf(field);
    if (err) err.hidden = !bad;
  };

  const missing = () => fields().filter((f) => {
    if (f.type === 'checkbox' || f.type === 'radio') return false;
    const bad = !String(f.value || '').trim();
    mark(f, bad);
    return bad;
  });

  document.addEventListener('change', (e) => {
    const f = e.target.closest && e.target.closest('.bc-option select, .bc-option input, .bc-option textarea');
    if (f && String(f.value || '').trim()) mark(f, false);
  });

  // Capture phase, so this runs before the theme's own submit handler.
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
    const all = fields();
    if (!all.length) return;
    const mainId = all[0].getAttribute('form');
    // The form holds a field named "id", which shadows form.id, so read the attribute.
    const formId = form.getAttribute('id');
    if (!mainId || (formId !== mainId && formId !== mainId + '--alt')) return;

    const bad = missing();
    if (bad.length) {
      e.preventDefault();
      e.stopImmediatePropagation();
      const first = bad[0];
      first.closest('.bc-option').scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => first.focus({ preventScroll: true }), 350);
      return;
    }

    // The sticky bar is its own form: give it the same choices.
    if (formId !== mainId) {
      form.querySelectorAll('input[data-bc-copied]').forEach((el) => el.remove());
      document.querySelectorAll('.bc-option [name^="properties["]').forEach((src) => {
        if ((src.type === 'checkbox' || src.type === 'radio') && !src.checked) return;
        if (!String(src.value || '').trim()) return;
        const copy = document.createElement('input');
        copy.type = 'hidden'; copy.name = src.name; copy.value = src.value; copy.setAttribute('data-bc-copied', '');
        form.appendChild(copy);
      });
    }
  }, true);
})();
